<div *ngIf="notificaciones!=null" class="listado-page">
    <div class="listado__stats">
        <div class="listado__stat">
            <div class="listado__stat-value">{{ totalNotificaciones }}</div>
            <div class="listado__stat-label">{{ 'COMMON.LIST.TOTAL' | translate }}</div>
        </div>
        <div class="listado__stat">
            <div class="listado__stat-value is-muted">{{ notificacionesMostradas }}</div>
            <div class="listado__stat-label">{{ 'COMMON.LIST.SHOWING' | translate }}</div>
        </div>
    </div>

    <div class="listado-table-wrapper listado listado--cards-accent">
        <table mat-table *ngIf="dataSource" #table [dataSource]="dataSource" matSort class="mat-elevation-z0">

            <ng-container matColumnDef="Identificador">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'NOTIFICATION.DETAIL.IDENTIFIER' | translate }}</th>
                <td mat-cell *matCellDef="let object" class="click"
                    [attr.data-label]="'NOTIFICATION.DETAIL.IDENTIFIER' | translate" data-role="title"
                    (click)="(object['Estado'] === 'ACEPTADA' || object['Estado'] === 'RECHAZADA') && notificacionAcept(object['Destinatario'])">
                    {{ object['Identificador'] }}
                </td>
            </ng-container>

            <ng-container matColumnDef="Fecha disposición">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'NOTIFICATION.DETAIL.DISPOSITION_DATE' | translate }}</th>
                <td mat-cell *matCellDef="let object" class="click" [attr.data-label]="'NOTIFICATION.DETAIL.DISPOSITION_DATE' | translate" data-role="meta"
                    (click)="(object['Estado'] === 'ACEPTADA' || object['Estado'] === 'RECHAZADA') && notificacionAcept(object['Destinatario'])">
                    {{ formatDate(object['Fecha disposición']) }}
                </td>
            </ng-container>

            <ng-container matColumnDef="Entidad">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'NOTIFICATION.DETAIL.ENTITY' | translate }}</th>
                <td mat-cell *matCellDef="let object" class="click" [attr.data-label]="'NOTIFICATION.DETAIL.ENTITY' | translate"
                    (click)="(object['Estado'] === 'ACEPTADA' || object['Estado'] === 'RECHAZADA') && notificacionAcept(object['Destinatario'])">
                    {{ object['Entidad'] }}
                </td>
            </ng-container>

            <ng-container matColumnDef="Estado">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'NOTIFICATION.DETAIL.STATUS' | translate }}</th>
                <td mat-cell *matCellDef="let object" class="click" [attr.data-label]="'NOTIFICATION.DETAIL.STATUS' | translate" data-role="status"
                    (click)="(object['Estado'] === 'ACEPTADA' || object['Estado'] === 'RECHAZADA') && notificacionAcept(object['Destinatario'])">
                    {{ ('NOTIFICATION.STATUS.' + object['Estado']) | translate }}
                </td>
            </ng-container>

            <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef class="em-th-actions">{{ 'TRAMITE_LIST.COLUMN.ACTIONS' | translate }}</th>
                <td mat-cell *matCellDef="let object" class="em-td-actions" data-role="actions" [attr.data-label]="'TRAMITE_LIST.COLUMN.ACTIONS' | translate">
                    <div class="em-actions-wrap">
                        <button type="button" class="em-icon-btn"
                            *ngIf="object['Estado'] === 'ACEPTADA' || object['Estado'] === 'RECHAZADA'"
                            [matTooltip]="'TRAMITE_LIST.ACTION.DOWNLOAD' | translate"
                            matTooltipClass="em-tooltip"
                            matTooltipPosition="left"
                            (click)="notificacionAcept(object['Destinatario'])">
                            <img src="assets/gestion-tramites/download.svg" alt="">
                        </button>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns.concat(['acciones'])"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns.concat(['acciones']);"></tr>
        </table>
    </div>

    <mat-paginator [pageSizeOptions]="[5, 10, 25]" [pageSize]="5" showFirstLastButtons></mat-paginator>
    <div class="w-100 mt-3 alertPuestosNot">
        <img src="assets/triangle-exclamation.svg" class="iconAlertNot"/>{{ 'NOTIFICATION.LAST_YEAR_ONLY' | translate }}</div>
</div>
<app-comunicacion-detalles [display]="display" [notificacionActivada]="notificacionActivada" (displayOut)="close($event)"></app-comunicacion-detalles>
